var makeObject = {
  "ACURA": {
    "MDX": ["2007", "2008", "2009", "2010", "2011", "2012", "2013"],
  },
  "ALFA-ROMEO": {
    "156": ["2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007"],
    "159": ["2006", "2007", "2008", "2009", "2010", "2011"]
  },

  "AUDI": {
    "A3": ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012"],
    "A4": ["1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "A6": ["1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "Q3": ["2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "Q5": ["2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "Q7": ["2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"]
  },

   "BMW": {
    "SERIES-2": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "SERIES-5": ["1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010"],
    "IX1": ["2022", "2023", "2024", "2025", "2024"],
    "X1": ["2009","2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "X2": ["2018", "2019", "2020", "2021", "2022"],
    "X3": ["2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "X4": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "X5": ["2000", "2001", "2002", "2003", "2004", "2005", "2006", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "X7": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"]
  },

 

  "CADILLAC": {
    "ESCALADE": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "XT5": ["2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "SRX": ["2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "XT6": ["2020", "2021", "2022", "2023", "2024", "2025"]
  },

  
  "CHEVROLET": {
    "BOLT": ["2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "CAPTIVA": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "SUBURBAN": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "TAHOE": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "TRAX": ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  },

  "DODGE": {
    "JOURNEY": ["2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "NEON": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  },


  "FORD": {
    "BRONCO": ["2021", "2022", "2023", "2024", "2025"],
    "CONNECT": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022","2023", "2024", "2025"],
    "COURIER": ["2014", "2015", "2016", "2017","2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "CUSTOM": ["2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "EDGE": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "ESCAPE": [ "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    
    "FOCUS": ["1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "GALAXY": ["2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "GRAND C-MAX": ["2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "KUGA": ["2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "MONDEO": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "RANGER": ["2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022",],
    "S-MAX": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  },
  
  "GENESIS": {
    "GV70": ["2022", "2023", "2024", "2025"],
    "GV80": ["2021","2022", "2023", "2024", "2025"],
  },

  "GMC": {
    "YUKON": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "ACADIA": ["2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014","2015", "2016"],
    
  },

 

  "HONDA": {
    
    "PILOT": ["2009", "2010", "2011", "2012", "2013", "2014", "2015"],
    "PASSPORT": ["2019", "2020", "2021", "2022", "2023", "2024"],
    "ODYSSEY": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014","2015", "2016", "2017"],
  },

  "HYUNDAI": {
    "BAYON": ["2021","2022", "2023", "2024", "2025"],
   
    "KONA": ["2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "NIRO": ["2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "MATRIX": ["2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010"],
    "PALISADE": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "SANTACRUZ": ["2022", "2023", "2024", "2025"],
    "SANTAFE": ["2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "TRAJET": ["2000","2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008"],
    "TUCSON": ["2004", "2005", "2006", "2007", "2008", "2009", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "VENUE": ["2020", "2021", "2022", "2023", "2024", "2025"],
  },

  "INFINITI": {
    "EX": ["2008", "2009", "2010", "2011", "2012", "2013"],
    "FX": ["2003","2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "QX30": ["2016", "2017", "2018", "2019"],
    "QX50": ["2014", "2015", "2016", "2017"],
    "QX55": ["2022", "2023", "2024", "2025"],
    "QX56": ["2011", "2012", "2013"],
    "QX70": ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "QX80": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  },
  
  "JEEP": {
    "CHEROKEE": ["2002", "2003","2004", "2005", "2006", "2007"],
    "COMPASS": ["2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "GRAND-CHEROKEE": ["2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "LIBERTY": ["2002", "2003", "2004", "2005", "2006", "2007",],
    "PATRIOT": ["2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017",],
    "RENEGADE": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  },

  "KIA": {
    "BORREGO": ["2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "CARNIVAL": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014","2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    
    "GRAND-CARNIVAL": ["2015", "2016", "2017", "2018", "2019", "2020"],
    "GRAND-SEDONA": ["2015", "2016", "2017", "2018", "2019", "2020","2021"],
    "EV9": ["2024", "2025"],
    "MOHAVE": [ "2008", "2009", "2010", "2011", "2012", "2013", "2014","2015", "2016", "2017", "2018", "2019","2020", "2021", "2022", "2023", "2024", "2025"],
    "NIRO": ["2017", "2018", "2019","2020", "2021", "2022",],
    "OPTIMA": ["2016", "2017", "2018", "2019","2020", "2021"],
    "SEDONA": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"],
    "SORENTO": ["2002", "2003","2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "SOUL": ["2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "SPORTAGE": ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "SELTOS": ["2021", "2022", "2023", "2024"],
    "TELLURİDE": ["2020", "2021", "2022", "2023", "2024"],
  },


  "LAND-ROVER": {
    "FREELANDER 1": ["1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006"],
    "RANGE-ROVER-SPORT": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  },

  "LEXUS": {
    "LX": ["2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "NX": ["2015", "2016", "2017", "2018", "2019", "2020", "2021"],
    "RX": ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "RXL": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "UX": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  },
  

  "MAZDA": {
    "6": ["2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "XC-50": ["2023", "2024", "2025"],
    "XC-5": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  },

  "MERCEDES-BENZ": {
    "C-CLASS": ["2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "E-CLASS": ["2004", "2005", "2006", "2007", "2008", "2009"],
    "EQB": ["2021", "2022", "2023", "2024", "2025"],
    "GL-CLASS": ["2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "GLA-CLASS": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "GLB-CLASS": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "GLC-CLASS": ["2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    "GLK-CLASS": ["2009", "2010", "2011", "2012", "2013", "2014", "2015"],
    "GLS-CLASS": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "GLE-CLASS": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"  ],
    "M-CLASS": ["1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005","2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    "METRIS": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "TOURER": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "V-CLASS ": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "VIANO": ["2003", "2004", "2005","2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    "VITO": ["2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "X-CLASS": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  },

  "MG": {
    "EHS": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "ZS CROSSOVER": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  },

  "MINI": {
    "COUNTRYMAN": ["2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  },

  "MITSUBISHI": {
    
    "ASX": ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    "ECLIPSE CROSS": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
   
    "OUTLANDER": ["2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
    
    "RVR": ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"],
  },

  "NISSAN": {
    "ARMADA": ["2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
   
    "NP300": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "PATHFINDER": ["2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012",],
    "PATROL": ["2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "PRIMERA": ["1991", "1992", "1993", "1994", "1995", "1996", "1997"],
    
    "X-TRAIL": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  },


  "PORSCHE": {
    "CAYENNE": ["2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018"],
    "MACAN": ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  },

  "RAM": {
    "PROMASTER CITY": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "V1000": ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018","2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  },


  "SATURN": {
    "VUE": ["2008", "2009", "2010"],
  },

  "SUBARU": {
    "ASCENT": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "EVOLTIS": ["2020", "2021", "2022", "2023", "2024", "2025"],
    "FORESTER": ["1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "IMPREZA": ["2001", "2002", "2003", "2004", "2005", "2006", "2007",],
    "LEGACY": ["1994","1995","1996","1997", "1998", "1999","2000", "2001", "2002", "2003", "2004"],
    "OUTBACK": ["1994","1995","1996","1997", "1998", "1999","2000", "2001", "2002", "2003", "2004"],
    "XV": ["2012", "2013", "2014", "2015", "2016", "2017","2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  },

  "SUZUKI": {
    "ESCUDO": ["2015", "2016", "2017","2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "GRAND VITARA": ["1998", "1999","2000", "2001", "2002", "2003", "2004","2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014"],
    
    "VITARA": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  
   
  },

  "TOYOTA": {
      
    "COROLLA": ["2000", "2001", "2002", "2003", "2004","2005", "2006", "2007", "2008",],
    "FORTUNER": ["2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "HIGHLANDER": ["2008", "2009", "2010", "2011", "2012", "2013",],
    "LAND-CRUISER": ["2008", "2009", "2010", "2011", "2012", "2013", "2014","2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "PROACE-CITY": ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "RAV4": ["2013", "2014","2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "SIENNA": ["1998", "1999","2000", "2001", "2002", "2003"],
    "4RUNNER": ["2010", "2011", "2012", "2013", "2014","2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    
  },

  "VOLKSWAGEN": {
    "ATLAS": ["2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
    "JETTA": ["2009", "2010", "2011", "2012", "2013", "2014"],    
    "ID.4": ["2021", "2022", "2023", "2024", "2025"],    
    "NIVUS": ["2021", "2022", "2023", "2024", "2025"],
    "PASSAT": ["2010", "2011", "2012", "2013", "2014","2015", "2016", "2017", "2018", "2019","2020", "2021", "2022", "2023", "2024", "2025"],
    "SHUTTLE": ["2016", "2017", "2018", "2019","2020", "2021", "2022", "2023", "2024", "2025"],  
    "TAIGO": ["2021", "2022", "2023", "2024", "2025"],
    "TAOS": ["2021", "2022", "2023", "2024", "2025"],
    "TERAMONT": ["2018", "2019","2020", "2021", "2022", "2023", "2024", "2025"],
    "TIGUAN": ["2016", "2017", "2018", "2019","2020", "2021", "2022", "2023", "2024", "2025"],
    "TOUAREG": ["2011", "2012", "2013", "2014","2015", "2016", "2017", "2018", "2019","2020", "2021", "2022", "2023", "2024", "2025"],
   
  },

  "VOLVO": {
    "V50": ["2004","2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012",],
    "V60": ["2011", "2012", "2013", "2014","2015", "2016", "2017", "2018",],
    "V90": ["2017", "2018", "2019","2020", "2021", "2022", "2023", "2024", "2025"],
    "XC40": ["2018", "2019","2020", "2021", "2022", "2023", "2024", "2025"],
    "XC60": ["2018", "2019","2020", "2021", "2022", "2023", "2024", "2025"],
    "XC70": ["1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    "XC90": ["2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  },


}


